import LazyWrapper from './_LazyWrapper.js';
import getData from './_getData.js';
import getFuncName from './_getFuncName.js';
import lodash from './wrapperLodash.js';

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

export default isLaziable;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_isLaziable.js
// module id = 1103
// module chunks = 67